(function () {
	var App = angular.module('pphhApp');
	App.controller("updateObsoleteEntitiesController", ["$scope", "$window","$http","$mdDialog", "updateObsoleteEntitiesService",
		function($scope, $window,$http, $mdDialog, updateObsoleteEntitiesService) {
	
			$scope.mastercNames = "";
			$scope.table = "";
			$scope.relatedTable = "";
			$scope.relatedField = "";
			$scope.filter = {};
			$scope.candidates = "";
			$scope.pageSize = 10;
			$scope.filterResults = [];
			$scope.isLoading = false;
			$scope.selectedCandidates = [];
			$scope.seleccionMultiple = false;			
			$scope.init = function () {
				$scope.getListMC();
	
			};
	
			$scope.initAnalyze = function (table, relatedTable, relatedField, seleccionMultiple) {
				$scope.table = table;
				$scope.relatedTable = relatedTable;
				$scope.relatedField = relatedField;
				$scope.seleccionMultiple = seleccionMultiple;
			};
	
			/**
			 * Callback que se invoca cuando la operación de carga se ha realizado
			 * correctamente.
			 */
			var getListMCSuccessCallback = function (response) {
				$scope.mastercNames = response.lst;
				$scope.filter.mastercName = $scope.mastercNames[0].name;
	
			};
	
	
			$scope.getListMC = function() {
				updateObsoleteEntitiesService.listMasterCodes().then(getListMCSuccessCallback);
			}
	
	
			$scope.doFilter = function(tableState, ctrl) {
				$scope.isLoading = true;
				updateObsoleteEntitiesService.getNumberObseleteRecords($scope.filter.mastercName)
				.then(
					function(response) {
						$scope.filterResults = response.data;
						$scope.isLoading = false;
					},
					function(reponse) {
						$mdDialog.show(
								$mdDialog.alert({
									title: UIMessages.dialog.confirm.title,
									textContent: "Error Get",
									ok: UIMessages.dialog.confirm.cerrar,
									multiple: true
								}));
						$scope.isLoading = false;
					
					}
				);
			};
	
			$scope.doSearch = function(tableState, ctrl) {
				if(!$scope.stCtrl && ctrl) {
			        $scope.stCtrl = ctrl;
			    }
	
			    if(!tableState && $scope.stCtrl) {
			        $scope.stCtrl.pipe();
			        return;
			    }
	
				$scope.isLoading = true;
	
				var fullFilter =
					SmartTableUtils.copyAndSetGenericPaginationParams(
							tableState, $scope.filter);
				updateObsoleteEntitiesService.getObseleteRecords($scope.relatedTable,$scope.relatedField,fullFilter)
				.then(
					function(response) {
						var queryResults = response.data;
						if(response.data.results) {
							$scope.filterResults = queryResults.results;
							$scope.pageSize = queryResults.pageSize;
							SmartTableUtils.updateTableState(tableState, queryResults);
						}
						$scope.isLoading = false;
					},
					function(reponse) {						
						$mdDialog.show(
								$mdDialog.alert({
									title: UIMessages.dialog.confirm.title,
									textContent: "Error Get",
									ok: UIMessages.dialog.confirm.cerrar,
									multiple: true
								}));
						$scope.isLoading = false;
					}
				);
			};
	
	
			$scope.toggle = function (relatedId, oldId, newId, list) {
	
				var item = {};
				item.relatedId = relatedId;
				item.oldId = oldId;
				item.newId = newId;
		        var idx = list.findIndex(function(item) {
		        	  return item.relatedId == relatedId && item.oldId == oldId && item.newId == newId;
		        	});
		        if (idx > -1) {
		          list.splice(idx, 1);
		        }else {
		          list.push(item);
		        }
		      };
	
		    $scope.confirmSelected = function(){
	
		    	var confirm = null;
				confirm = $mdDialog.confirm()
				.clickOutsideToClose(true)
				.title(UIMessages.dialog.confirm.title)
				.htmlContent(UIMessages.updateObsoleteEntities.confirmChanges)
				.ok(UIMessages.dialog.confirm.ok)
				.cancel(UIMessages.dialog.confirm.cancel);
	
				$mdDialog.show(confirm)
				.then(
						function () {
							$scope.isLoading = true;
							updateObsoleteEntitiesService.updateSelectedObsoleteRecords($scope.table, $scope.relatedTable, $scope.selectedCandidates)
							.then(
								function(response) {
									$scope.isLoading = false;
									$window.location.href = _contextPath +"/updateObsoleteEntities/"+ $scope.table + "/" + $scope.relatedTable+ "/" + $scope.seleccionMultiple;
								},
								function(reponse) {						
									$mdDialog.show(
											$mdDialog.alert({
												title: UIMessages.dialog.confirm.title,
												textContent: "Error Get",
												ok: UIMessages.dialog.confirm.cerrar,
												multiple: true
											}));
									$scope.isLoading = false;
								}
							);
						}
				);
	
	
		    };
	
			$scope.execute = function (row) {
				$window.location.href = _contextPath + "/updateObsoleteEntities/"+ row.entidad + "/" + row.tablaRel + "/" + row.campoRel  + "/" + row.seleccionMultiple;
			};
			$scope.volverPrincipal= function () {
				$window.location.href = _contextPath + "/updateObsoleteEntities/";
			}	
	
			$scope.openSearchCodeDialog = function(registro) {
	
				$mdDialog.show({
					clickOutsideToClose: true,
					parent: angular.element(document.body),
					locals: {
						cicloId: this.cicloId,
						table: $scope.table,
						seleccionMultiple : $scope.seleccionMultiple
					},
					controller: SearchCodeDialogController,
					templateUrl: _contextPath + "/updateObsoleteEntities/searchCode"
				}).then(function (selected) {
					if(!selected) {
						return;
					}
					if(selected.length > 0) {
						registro.splice(0, registro.length);
						for(var i = 0; i < selected.length; i++) {
							registro.push(selected[i])
						}
					}
				});
			};
	
	
	
			function SearchCodeDialogController($scope, $mdDialog, $http,cicloId,table,seleccionMultiple) {
	
				$scope.filter = {};
				$scope.selectedRows = [];
	
				$scope.lookup = function() {
					var tableState = $scope.stCtrl.tableState();
					SmartTableUtils.reset(tableState);
					$scope.stCtrl.pipe();
				}
	
	
	
				$scope.doLookup = function (tableState, ctrl) {
	
					if(!$scope.stCtrl && ctrl) {
				        $scope.stCtrl = ctrl;
				    }
	
				    if(!tableState && $scope.stCtrl) {
				        $scope.stCtrl.pipe();
				        return;
				    }
				    SmartTableUtils.setGenericPaginationParams(tableState, $scope.filter);
				    $http({
						method: "GET",
						url: _contextPath + "/updateObsoleteEntities/listTableCodes/" + table,
						params: $scope.filter
					})
					.then(
						function (response) {
							var queryResults = response.data;
							if(response.data.results) {
								$scope.sourceResults = queryResults.results;
								$scope.sourcePageSize = queryResults.pageSize;
								SmartTableUtils.updateTableState(tableState, queryResults);
							}
						},
						function (response) {
							$mdDialog.show(
									$mdDialog.alert({
										title: UIMessages.dialog.confirm.title,
										textContent: "Error lookup",
										ok: UIMessages.dialog.confirm.cerrar
									}));
						}
					);
				};
	
	
				$scope.selectOnSource = function(row) {
						var found = false;
						for(i = 0; !found && i < $scope.selectedRows.length; i++) {
							found = $scope.selectedRows[i].id == row.id;
						}
						if(!found) {
							$scope.selectedRows[$scope.selectedRows.length] = {
								id: row.id,
								code: row.code,
								desc: row.desc
							};
						}
					if (seleccionMultiple=='false')
						$scope.endSelection();
					};
	
				$scope.deselectValue = function(index) {
					$scope.selectedRows.splice(index, 1);
				};
	
				$scope.endSelection = function () {
					$mdDialog.hide($scope.selectedRows);
				};
	
				$scope.closeDialog = function() {
					$mdDialog.hide();
			    };
	
			}
	
	}]);
})();
